export default "__VITE_ASSET__ykDexsqC__"